<ng-container
  *ngIf="
    platformService?.platformType !== platformService?.platformEnum?.mobile
  "
>
  <ion-header
    class="ion-no-border"
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'ion-header-modal-tablet'
          : 'ion-header-modal-mobile'
        : 'ion-header-modal-desktop'
    "
  >
    <ion-toolbar>
      <ion-buttons
        *ngIf="(platformService?.isTouchExperience$ | async) === false"
        slot="end"
      >
        <ion-button
          data-cy="close-update-price-modal-button"
          class="close-modal-button"
          (click)="dismiss()"
        >
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <h1 data-cy="update-product-price-title">
        {{ 'i18n.handPricing.updateProductPrice' | translate }}
      </h1>
    </ion-toolbar>
  </ion-header>
  <ion-content
    [ngClass]="
      (platformService?.isTouchExperience$ | async)
        ? platformService?.platformType ===
          platformService?.platformEnum?.tablet
          ? 'ion-content-modal-tablet'
          : 'ion-content-modal-mobile'
        : 'ion-content-modal-desktop'
    "
    scroll-y="true"
  >
    <p
      class="price-message"
      *ngIf="!!errorMessage"
      data-cy="update-price-error-text"
    >
      <ion-icon name="alert-circle-outline"></ion-icon>
      {{ errorMessage }}
    </p>

    <div
      class="product-tabs"
      *ngIf="!!productDetails?.description && !!altProductDetails?.description"
    >
      <button
        data-cy="update-price-original-product-tab"
        [ngClass]="{ active: currentTab === 1 }"
        (click)="toggleTab(1)"
      >
        {{ 'i18n.handPricing.originalProduct' | translate }}
      </button>
      <button
        data-cy="update-price-substitute-product-tab"
        [ngClass]="{ active: currentTab === 2 }"
        (click)="toggleTab(2)"
      >
        {{ 'i18n.handPricing.subProduct' | translate }}
      </button>
    </div>
    <div class="update-pricing-content">
      <div class="product-info">
        <div class="general-info">
          <app-usf-expandable-panel
            [collapseContent]="expandAdditionalPricing"
            [displayHeader]="false"
            noBorders
          >
            <div class="image-wrapper">
              <img
                *ngIf="!!prices?.xlargeImageURL"
                data-cy="hand-price-product-xl-image"
                src="{{ prices?.xlargeImageURL }}"
                alt="Product Image"
              />
              <img
                *ngIf="!prices?.xlargeImageURL && !!prices?.thumbnailImageURL"
                data-cy="hand-price-thumbnail-product-image"
                src="{{ prices?.thumbnailImageURL }}"
                alt="Product Image"
              />
              <ion-icon
                name="restaurant"
                *ngIf="!prices?.xlargeImageURL && !prices?.thumbnailImageURL"
                data-cy="hand-price-icon-image"
                class="no-image"
              >
              </ion-icon>
            </div>
          </app-usf-expandable-panel>
          <div class="brand" data-cy="hand-price-product-brand-text">
            {{ prices?.brand }}
          </div>
          <div class="prod-desc" data-cy="hand-price-product-description-text">
            {{ prices?.description }}
          </div>
          <div
            class="prod-number-pack-size"
            data-cy="hand-price-product-number-pack-size"
          >
            # {{ prices?.productNumber }} <span class="border">|</span>
            {{ prices?.packSize }}
          </div>
          <div
            class="original-price"
            data-cy="hand-price-product-current-price-text"
          >
            <span>Original Price:</span>

            <ng-container *ngIf="prices?.currentPrice">
              {{ prices?.currentPrice | currency }}
              {{ prices?.priceUom }}
            </ng-container>

            <span
              *ngIf="prices?.currentPrice && prices?.breakable"
              class="border"
              >|</span
            >

            <ng-container
              *ngIf="prices?.breakable"
              data-cy="hand-price-product-each-text"
            >
              {{ prices?.eachPrice | currency }}
              {{ prices?.priceUOM === 'LB' ? 'LB' : 'EA' }}
            </ng-container>
          </div>
        </div>
        <div class="additional-pricing">
          <app-usf-expandable-panel
            [collapseContent]="true"
            [showArrow]="false"
            [stylesObject]="{ updateHeader: true }"
            noBorders
          >
            <button
              data-cy="expand-hand-price-additional-pricing-button"
              (click)="expandAdditionalPricing = !expandAdditionalPricing"
              header
            >
              <ion-icon
                name="add-circle-outline"
                color="primary"
                *ngIf="!expandAdditionalPricing"
              ></ion-icon>
              <ion-icon
                name="remove-circle-outline"
                color="primary"
                *ngIf="expandAdditionalPricing"
              ></ion-icon>
              {{ 'i18n.handPricing.additionalPricing.title' | translate }}
            </button>
            <div class="additional-pricing-details">
              <div>
                <span class="label" data-cy="hand-price-current-price-label"
                  >{{
                    'i18n.handPricing.additionalPricing.current' | translate
                  }}: </span
                ><span data-cy="hand-price-unit-price-text"
                  >{{ prices.additionalPricingInfo.unitPrice | currency }}
                  {{ 'i18n.orderPage.cs' | translate }}</span
                ><span
                  data-cy="hand-price-price-info-text"
                  *ngIf="prices?.breakable"
                  >{{ prices.additionalPricingInfo.eachPrice | currency }}
                  {{ 'i18n.orderPage.ea' | translate }}</span
                >
              </div>
              <div>
                <span class="label" data-cy="hand-price-commision-amount-label"
                  >{{
                    'i18n.handPricing.additionalPricing.com' | translate
                  }}: </span
                ><span data-cy="hand-price-commision-amount-text"
                  >{{
                    prices.additionalPricingInfo.commissionAmount | currency
                  }}
                  {{ 'i18n.orderPage.cs' | translate }}</span
                >
              </div>
              <div>
                <span class="label" data-cy="hand-price-acs-label"
                  >{{
                    'i18n.handPricing.additionalPricing.ascInd' | translate
                  }}: </span
                ><span data-cy="hand-price-acs-text">{{
                  sellerPrice?.customerAscInd
                }}</span>
              </div>
              <div>
                <span class="label" data-cy="hand-price-acs-charge-label"
                  >{{
                    'i18n.handPricing.additionalPricing.ascCharge' | translate
                  }}: </span
                ><span data-cy="hand-price-acs-charge-text"
                  >{{ prices.additionalPricingInfo.unitAscRate | currency }}
                  {{ 'i18n.orderPage.cs' | translate }}</span
                ><span
                  *ngIf="prices?.breakable"
                  data-cy="hand-price-acs-charge-rate-text"
                  >{{ prices.additionalPricingInfo.eachAscRate | currency }}
                  {{ 'i18n.orderPage.ea' | translate }}</span
                >
              </div>
              <div>
                <span class="label" data-cy="hand-price-gpp-label"
                  >{{
                    'i18n.handPricing.additionalPricing.gpp' | translate
                  }}: </span
                ><span data-cy="hand-price-gpp-text">{{
                  prices.additionalPricingInfo.grossProfitPercent / 100
                    | percent: '1.2-2'
                }}</span>
              </div>
              <div>
                <span class="label" data-cy="hand-price-gdp-label"
                  >{{
                    'i18n.handPricing.additionalPricing.gpd' | translate
                  }}: </span
                ><span data-cy="hand-price-gdp-text"
                  >{{
                    prices.additionalPricingInfo.grossProfitDollars | currency
                  }}
                </span>
              </div>
            </div>
          </app-usf-expandable-panel>
        </div>
      </div>
      <div class="price-options">
        <div class="include-asc-container">
          <span
            *ngIf="sellerPrice?.customerAscInd === 'P'"
            data-cy="hand-price-include-asc-label"
            >{{ 'i18n.handPricing.includeASC' | translate }}</span
          >
        </div>
        <mat-radio-group [formControl]="selectedPriceType">
          <div class="border-row">
            <mat-radio-button
              value="custom"
              data-cy="hand-price-set-custom-price-radio-button"
              >{{
                'i18n.handPricing.setCustomPrice' | translate
              }}</mat-radio-button
            >
            <div class="input-group">
              <div>
                <span class="semi-bold">$</span
                ><input
                  type="number"
                  step="0.01"
                  class="input"
                  data-cy="hand-price-set-custom-price-input"
                  [formControl]="customPrice"
                  placeholder="00.00"
                  (keypress)="allowOnlyNumbers($event)"
                /><span class="semi-bold">CS</span>
              </div>
            </div>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="minimum"
              data-cy="hand-price-set-min-price-radio-button"
              >{{ 'i18n.handPricing.changeMin' | translate }}</mat-radio-button
            >
            <p>{{ prices?.minimum | currency }} CS</p>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="target"
              data-cy="hand-price-set-target-price-radio-button"
              >{{
                'i18n.handPricing.changeTarget' | translate
              }}</mat-radio-button
            >
            <p>{{ prices?.target | currency }} CS</p>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="maximum"
              data-cy="hand-price-set-max-price-radio-button"
              >{{ 'i18n.handPricing.changeMax' | translate }}</mat-radio-button
            >
            <p>{{ prices?.maximum | currency }} CS</p>
          </div>
        </mat-radio-group>
      </div>
    </div>
  </ion-content>
  <ion-footer class="ion-footer-modal">
    <ion-toolbar>
      <ion-buttons>
        <ion-button
          class="usf-outline-green-dsktp-tblt-modal-button"
          data-cy="update-hand-price-button"
          (click)="updatePrice()"
        >
          {{ 'i18n.common.update' | translate }}
        </ion-button>
        <ion-button
          class="usf-fill-green-dsktp-tblt-modal-button"
          data-cy="cancel-hand-price-button"
          (click)="dismiss()"
        >
          {{ 'i18n.common.cancel' | translate }}
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ng-container>

<div id="mobile">
  <div class="popover-wrapper">
    <h1 data-cy="update-product-price-mobile-title">
      {{ 'i18n.handPricing.changeMax' | translate }}
    </h1>
    <p
      class="price-message"
      *ngIf="!!errorMessage"
      data-cy="update-price-error-message-text"
    >
      <ion-icon name="alert-circle-outline"></ion-icon>
      {{ errorMessage }}
    </p>
    <div
      class="product-tabs"
      *ngIf="!!productDetails?.description && !!altProductDetails?.description"
    >
      <button
        data-cy="update-price-original-product-tab"
        [ngClass]="{ active: currentTab === 1 }"
        (click)="toggleTab(1)"
      >
        {{ 'i18n.handPricing.originalProduct' | translate }}
      </button>
      <button
        data-cy="update-price-substitute-product-tab"
        [ngClass]="{ active: currentTab === 2 }"
        (click)="toggleTab(2)"
      >
        {{ 'i18n.handPricing.subProduct' | translate }}
      </button>
    </div>
    <ng-container *ngIf="!!prices">
      <div class="product-info">
        <div class="image-wrapper">
          <img
            *ngIf="!!prices?.thumbnailImageURL"
            data-cy="hand-price-product-thumbnail-image"
            src="{{ prices?.thumbnailImageURL }}"
            alt="Product Image"
          />
          <ion-icon
            name="restaurant"
            *ngIf="!prices?.thumbnailImageURL"
            data-cy="hand-price-icon-image"
            class="no-image"
          ></ion-icon>
        </div>
        <div class="product-info-desc">
          <div class="brand" data-cy="hand-price-product-brand-text">
            {{ prices?.brand }}
          </div>
          <div class="prod-desc" data-cy="hand-price-product-description-text">
            {{ prices?.description }}
          </div>
        </div>
      </div>
      <div class="product-info-other">
        <div
          class="prod-number-pack-size"
          data-cy="hand-price-product-number-text"
        >
          # {{ prices?.productNumber }}<span class="border">|</span
          >{{ prices?.packSize }}
        </div>
        <div class="original-price" data-cy="hand-price-original-price-label">
          <span>Original Price:</span>

          <ng-container *ngIf="prices?.currentPrice">
            {{ prices?.currentPrice | currency }}
            {{ prices?.priceUom }}
          </ng-container>

          <span *ngIf="prices?.currentPrice && prices?.breakable" class="border"
            >|</span
          >

          <ng-container
            *ngIf="prices?.breakable"
            data-cy="hand-price-product-each-text"
          >
            {{ prices?.eachPrice | currency }}
            {{ prices?.priceUOM === 'LB' ? 'LB' : 'EA' }}
          </ng-container>
        </div>
      </div>
      <div class="additional-pricing">
        <app-usf-expandable-panel
          [collapseContent]="true"
          [showArrow]="false"
          [stylesObject]="{ updateHeader: true }"
          noBorders
        >
          <button
            data-cy="expand-hand-price-additional-pricing-button"
            (click)="expandAdditionalPricing = !expandAdditionalPricing"
            header
          >
            <ion-icon
              name="add-circle-outline"
              color="primary"
              *ngIf="!expandAdditionalPricing"
            ></ion-icon>
            <ion-icon
              name="remove-circle-outline"
              color="primary"
              *ngIf="expandAdditionalPricing"
            ></ion-icon>
            {{ 'i18n.handPricing.additionalPricing.title' | translate }}
          </button>
          <div class="additional-pricing-details">
            <div>
              <span class="label" data-cy="hand-price-current-price-label"
                >{{
                  'i18n.handPricing.additionalPricing.current' | translate
                }}: </span
              ><span data-cy="hand-price-unit-price-text"
                >{{ prices.additionalPricingInfo.unitPrice | currency }}
                {{ 'i18n.orderPage.cs' | translate }}</span
              ><span
                *ngIf="prices?.breakable"
                data-cy="hand-price-price-info-text"
                >{{ prices.additionalPricingInfo.eachPrice | currency }}
                {{ 'i18n.orderPage.ea' | translate }}</span
              >
            </div>
            <div>
              <span class="label" data-cy="hand-price-commision-amount-label"
                >{{
                  'i18n.handPricing.additionalPricing.com' | translate
                }}: </span
              ><span data-cy="hand-price-commision-amount-text"
                >{{ prices.additionalPricingInfo.commissionAmount | currency }}
                {{ 'i18n.orderPage.cs' | translate }}</span
              >
            </div>
            <div>
              <span class="label" data-cy="hand-price-acs-label"
                >{{
                  'i18n.handPricing.additionalPricing.ascInd' | translate
                }}: </span
              ><span>{{ sellerPrice?.customerAscInd }}</span>
            </div>
            <div>
              <span class="label" data-cy="hand-price-acs-charge-label"
                >{{
                  'i18n.handPricing.additionalPricing.ascCharge' | translate
                }}: </span
              ><span data-cy="hand-price-acs-charge-text"
                >{{ prices.additionalPricingInfo.unitAscRate | currency }}
                {{ 'i18n.orderPage.cs' | translate }}</span
              ><span
                *ngIf="prices?.breakable"
                data-cy="hand-price-acs-charge-rate-text"
                >{{ prices.additionalPricingInfo.eachAscRate | currency }}
                {{ 'i18n.orderPage.ea' | translate }}</span
              >
            </div>
            <div>
              <span class="label" data-cy="hand-price-gpp-label"
                >{{
                  'i18n.handPricing.additionalPricing.gpp' | translate
                }}: </span
              ><span data-cy="hand-price-gpp-text">{{
                prices.additionalPricingInfo.grossProfitPercent / 100
                  | percent: '1.2-2'
              }}</span>
            </div>
            <div>
              <span class="label" data-cy="hand-price-additional-gpp-text"
                >{{
                  'i18n.handPricing.additionalPricing.gpd' | translate
                }}: </span
              ><span data-cy="hand-price-additional-gdp-text"
                >{{
                  prices.additionalPricingInfo.grossProfitDollars | currency
                }}
              </span>
            </div>
          </div>
        </app-usf-expandable-panel>
      </div>
      <div class="price-options">
        <span
          *ngIf="sellerPrice?.customerAscInd === 'P'"
          data-cy="hand-price-include-asc-label"
          >{{ 'i18n.handPricing.includeASC' | translate }}</span
        >
        <mat-radio-group [formControl]="selectedPriceType">
          <div class="border-row">
            <mat-radio-button
              value="custom"
              data-cy="hand-price-set-custom-price-radio-button"
              >Set Custom Price</mat-radio-button
            >
            <div class="input-group">
              <div>
                <span class="semi-bold">$</span
                ><input
                  type="number"
                  step="0.01"
                  class="input"
                  data-cy="hand-price-set-custom-price-input"
                  [formControl]="customPrice"
                  placeholder="00.00"
                  (keypress)="allowOnlyNumbers($event)"
                /><span class="semi-bold">CS</span>
              </div>
            </div>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="minimum"
              data-cy="hand-price-set-min-price-radio-button"
              >{{ 'i18n.handPricing.changeMin' | translate }}</mat-radio-button
            >
            <p>{{ prices?.minimum | currency }} CS</p>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="target"
              data-cy="hand-price-set-target-price-radio-button"
              >{{
                'i18n.handPricing.changeTarget' | translate
              }}</mat-radio-button
            >
            <p>{{ prices?.target | currency }} CS</p>
          </div>
          <div class="border-row">
            <mat-radio-button
              value="maximum"
              data-cy="hand-price-set-max-price-radio-button"
              >{{ 'i18n.handPricing.changeMax' | translate }}</mat-radio-button
            >
            <p>{{ prices?.maximum | currency }} CS</p>
          </div>
        </mat-radio-group>
      </div>
    </ng-container>
  </div>
  <div class="modal-footer">
    <ion-button
      class="usf-fill-green-mobile-modal-button"
      data-cy="update-hand-price-button"
      shape="round"
      (click)="updatePrice()"
    >
      {{ 'i18n.common.update' | translate }}
    </ion-button>
    <ion-button
      class="usf-outline-green-mobile-modal-button"
      data-cy="cancel-hand-price-button"
      (click)="dismiss()"
    >
      {{ 'i18n.common.cancel' | translate }}
    </ion-button>
  </div>
</div>
